import { Component, h, useRef } from "@lukekaalim/act";
import { html } from "@lukekaalim/act-web";
import { TheatreState } from "../../hooks/useTheatreState";

import classes from './Overlay.module.css';
import { Animation, getAnimationPoint, useAnimatedNumber, useAnimation, useJeffect, useLogger } from "@kosmod/kit";
import { filter } from "rxjs";
import { inputBeat, renderBeat } from "@kosmod/graphics-3d";
import { lerp } from "three/src/math/MathUtils.js";
import { ContentBrowser } from "./ContentBrowser";
import { ToolbeltRenderer } from "../Tools/ToolbeltRenderer";

export type TheatreOverlayProps = {
  state: TheatreState,
}

const TOOLBELT_HEIGHT = 128;

export const TheatreOverlay: Component<TheatreOverlayProps> = ({ state }) => {
  const logger = useLogger('ContentBrowser');

  useJeffect(j => {
    const onKeyCPress = (event: KeyboardEvent) => {
      if (event.defaultPrevented)
        return;
      if (event.target instanceof HTMLElement && event.target.tagName === 'INPUT')
        return;
      logger.log(event);
      logger.log('C', state.viewMode)
      state.changeViewMode(state.viewMode === 'scene' ? 'content-browser' : 'scene');
    }
    j.add(state.keyboard.onKeyPress.pipe(filter(press => press.code === 'KeyC')).subscribe(onKeyCPress))
  }, [state.keyboard, state.viewMode])

  const ref = useRef<HTMLElement | null>(null);
  const viewModeAnim = useAnimatedNumber(state.viewMode === 'scene' ? 1 : 0, 500)

  inputBeat.useBeat(now => {
    const v = getAnimationPoint(viewModeAnim, now);
    const contentBrowserElement = ref.get()!;
    const offset = v * (state.graphics.canvas.get()!.height - TOOLBELT_HEIGHT);
    contentBrowserElement.style.transform = `translate(-50%, ${offset - 0}px)`
  })

  return h(html.div, { className: classes.overlay, ref }, [
    h(ToolbeltRenderer, { state }),
    h(ContentBrowser, { state })
  ])
};
